module.exports = __webpack_public_path__ + "static/media/background_writer2.a00a0b1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background_writer2.jpg
// module id = 621
// module chunks = 0